<template>
  <header>
    <div class="navbar navbar-default navbar-static-top">
        <div class="container">
            <div class="navbar-header">
                <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
                <router-link class="navbar-brand" to="/home"><img src="../assets/img/logo.jpg" style="width:350px;height:50px" alt="logo"/></router-link>
            </div>
            <div class="navbar-collapse collapse ">
                <ul class="nav navbar-nav">
                    <li><router-link to="/home">ホーム</router-link></li>
                    <li class="dropdown">
                    <a href="#" data-toggle="dropdown" class="dropdown-toggle" data-hover="dropdown" data-delay="0">会社情報<b class="caret"></b></a>
                        <ul class="dropdown-menu">
                            <li><router-link to="/company">会社概要</router-link></li>
                            <!--<li><a href="organiz.html">組織一覧</a></li>
                            <li><a href="#">会社沿革</a></li>-->
                            <li><router-link to="/news">ニュース・お知らせ</router-link></li> 
                        </ul>
                    </li> 
                    <li class="dropdown">
                    <a href="#" data-toggle="dropdown" class="dropdown-toggle" data-hover="dropdown" data-delay="0">業務内容<b class="caret"></b></a>
                        <ul class="dropdown-menu">
                            <li><router-link to="/ses">SESサービス</router-link></li>
                            <li><router-link to="/dev">ソフトウェア受託開発</router-link></li>
                            <!--<li><a href="#">IT人材派遣</a></li>-->
                            <li><a href="#">IT人材育成</a></li>
                        </ul>
                    </li>
                    <li><router-link to="/recruit">採用情報</router-link></li>
                    <!--<li><a href="event.html">イベント</a></li>-->
                    <li><router-link to="/contact">お問合せ</router-link></li>
                </ul>
            </div>
        </div>
    </div>
</header>
  </template>
  
  <script>
  export default {
    name: 'TopMenu',
    props: {
      msg: String
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  </style>
  